import moment from 'moment'

export const config = {
  rowSelection: false,
  columns: [
    {
      title: '编码',
      dataIndex: ['object', 'key'],
      width: 190,
    },
    {
      title: '名称',
      dataIndex: ['object', 'name'],
      width: 200,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '值',
      dataIndex: ['object', 'dataValue'],
      width: 200,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '排序',
      dataIndex: ['object', 'sortNumber'],
      width: 200,
    },
    {
      title: '描述',
      dataIndex: ['object', 'description'],
      width: 200,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '创建人',
      dataIndex: ['object', 'createdByName'],
      width: 200,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '创建时间',
      dataIndex: ['object', 'createdTime'],
      name: 'createdTime',
      width: 180,
      render: v => {
        return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
      },
    },
    {
      title: '是否启用',
      dataIndex: ['object', 'enabled'],
      width: 200,
      render: 'switchRender',
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '名称/编码',
      name: 'keyName',
    },
    {
      label: '是否启用',
      name: 'enabled',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        {
          label: '是',
          value: true,
        },
        { label: '否', value: false },
      ],
    },
    {
      label: '开始时间',
      name: 'startTime',
      itemType: 'date',
    },
    {
      label: '结束时间',
      name: 'endTime',
      itemType: 'date',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
}
